import React, { useMemo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import { Backspace } from '@material-ui/icons';

import { Input, Select, DateTime } from '~/components/Form';
import { number } from '~/helpers';

import * as S from './styles';

export default function Dados({ formRef }) {
  const [textArea, setTextArea] = useState(true);
  const [transponder, setTransponder] = useState(true);
  const [render, setRender] = useState(true);
  const [dvec, setDvec] = useState(true);
  const [tags, setTags] = useState({ one: '', two: '', three: '', dvec: '' });
  const [isDisabled, setIsDisabled] = useState(true)

  const user = useSelector(
    (state) => state.user.profile
  );

  const optionsVehicle = useMemo(
    () => [
      { value: 'A', label: 'Em uso' },
      { value: 'M', label: 'Manut/Acidentado' },
      { value: 'D', label: 'Impedimento DETRAN' },
      { value: 'F', label: 'Fora de uso' },
      { value: 'I', label: 'Inativo' },
      { value: 'P', label: 'Abastec anterior pendente SIAD' },
    ],
    []
  );

  const optionsSN = useMemo(
    () => [
      { value: 'S', label: 'Sim' },
      { value: 'N', label: 'Não' },
    ],
    []
  );

  const optionsSNNumber = useMemo(
    () => [
      { value: '1', label: 'Não' },
      { value: '0', label: 'Sim' },
    ],
    []
  );

  useEffect(() => {
    if (user.perfcodigo == "1")
      setIsDisabled(false)
  }, [user])

  useEffect(() => {
    if (!render) {
      const data = formRef.current.getData();

      setRender(true);
      setTags({
        one: data.veic_tag1,
        two: data.veic_tag2,

        three: data.veic_tag3, 

        dvec: data.veic_idxbee,
      });
    }
  }, [render]);

  useEffect(() => {
    if (formRef) {
      const data = formRef.current.getData();
      setTags({
        one: data.veic_tag1,
        two: data.veic_tag2,

        three: data.veic_tag3,

        dvec: data.veic_idxbee,
      });
    }
  }, [formRef]);

  return (
    <S.Container>
      <fieldset>
        <legend className="__legend">Veículo</legend>

        <Input disabled name="veic_placa_aux" label="Placa" />

        <Input disabled name="unid_nome" label="Unidade" />

        <Select
          disabled
          name="veic_status"
          label="Status"
          options={optionsVehicle}
        />

        <Input disabled name="orga_nome" label="Órgão" />

        <Input disabled name="veic_renavam" label="RENAVAM" />

        <Input disabled name="vemm_nome" label="Modelo" />

        <Input disabled name="veic_ano_fabricacao" label="Ano" />

        <Select
          name="veic_bloqueio_inadimplencia"
          variant="outlined"
          label="Bloqueio Por Contrato"
          options={optionsSN}
          getValue={(value) => setTextArea(value === 'N')}
          disabled={isDisabled}
        />

        <Input
          multiline
          name="veic_bloqueio_inadimplencia_observacao"
          label="Observação Bloqueio Por Contrato"
          rows={4}
          disabled={textArea || isDisabled}
        />
      </fieldset>

      <fieldset>
        <legend className="__legend">Transponder</legend>
        <Select
          name="veic_possui_transp"
          variant="outlined"
          label="Possui Transponder"
          options={optionsSNNumber}
          getValue={(value) => setTransponder(value === '0')}
          disabled
        />

        <ul>
          <li>
            <Input
              disabled
              name="veic_tag1"
              label="Transponder 01"
              value={tags.one}
            />

            {/* <IconButton
              color="primary"
              component="span"
              onClick={() => {
                formRef.current.clearField('veic_tag1');
                setRender(false);
              }}
            >
              <Backspace />
            </IconButton> */}
          </li>

          <li>
            <Input
              disabled
              name="veic_tag2"
              label="Transponder 02"
              value={tags.two}
            />

            {/* <IconButton
              color="primary"
              component="span"
              onClick={() => {
                formRef.current.clearField('veic_tag2');
                setRender(false);
              }}
            >
              <Backspace />
            </IconButton> */}
          </li>

          <li>
            <Input
              disabled
              name="veic_tag3"
              label="Transponder 03"
              value={tags.three}
            />

            {/* <IconButton
              color="primary"
              component="span"
              onClick={() => {
                formRef.current.clearField('veic_tag2');
                setRender(false);
              }}
            >
              <Backspace />
            </IconButton> */}
          </li>


        </ul>


        

        <Select
          name="veic_leituracontinuatransp"
          label="Leitura Contínua"
          options={optionsSNNumber}
          disabled={transponder || isDisabled}
        />
      </fieldset>

      <fieldset>
        <legend className="__legend">DVEC</legend>

        <Select
          name="veic_possui_dvec"
          label="Possui DVEC"
          options={optionsSNNumber}
          getValue={(value) => setDvec(value === '0')}
          disabled
        />

        <ul>
          <li>
            <Input disabled name="veic_idxbee" label="DVEC" value={tags.dvec} />

            {/* <IconButton
              color="primary"
              component="span"
              onClick={() => {
                formRef.current.clearField('veic_idxbee');
                setRender(false);
              }}
            >
              <Backspace />
            </IconButton> */}
          </li>
        </ul>

        <Input
          name="veic_afericao_dvec"
          label="Aferições DVEC"
          type="number"
          disabled={dvec || isDisabled}
        />

        <Input
          name="veic_abastscadaconfirm"
          label="Abastecimento entre cada Confirmação"
          type="number"
          disabled={dvec || isDisabled}
        />

        <Input
          name="veic_hodentrecadaconfirm"
          label="Hodômetro entre cada Confirmação"
          type="number"
          disabled={dvec || isDisabled}
        />

        <Input
          disabled
          name="veic_totalizador"
          label="Hodômetro"
          serialize={(value) => number(value, 1)}
        />
      </fieldset>

      <Input
        disabled
        name="veic_volume_tanque"
        label="Volume Tanque"
        serialize={(value) => number(value, 2)}
      />

      <DateTime
        name="veic_limite_sem_dvec"
        label="Data Limite Sem DVEC"
        serialize={(value) =>
          value
            .set({ hour: 0, minute: 0, seconds: 0 })
            .format('DD/MM/YYYY HH:mm:ss')
        }
        disabled={isDisabled}
      />

      <Select
        name="veic_bloqueado"
        label="Veículo Bloqueado"
        options={optionsSNNumber}
        disabled={isDisabled}
      />
      
    </S.Container>
  );
}

Dados.propTypes = {
  formRef: PropTypes.objectOf(PropTypes.any).isRequired,
};
